import { useState, useContext, useEffect, useCallback } from "react";
import "../../Styles/GlobalStyle.css";
import "../../Styles/SignIn.css";
import "react-datepicker/dist/react-datepicker.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import { jwtDecode } from 'jwt-decode';
import { UserInfo } from "../Context/UserInfoContext";
import { BasketContext } from '../Context/BasketContext';
import { Packs } from '../Context/PacksContext';
import { MedicalContext } from '../Context/MedicalContext';
import { googleLogout, useGoogleLogin } from '@react-oauth/google';
import allRegions from "../../../JSONS/chile_regions.json"
import axios from 'axios';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const SigninRoute = () => {

  const Navigate = useNavigate();
  const MySwal = withReactContent(Swal)

  const {
    setHabitsCalculated, setOpenAccess, SetRelatedExams, SetPreviewRelatedExams
  } = useContext(MedicalContext);

  const { 
    setLoggedIn, LoggedOut, setLoggedOut, SessionExpired, setSessionExpired
  } = useContext(UserInfo);

  const {
    SetBasketPacks, SetExamsPerProduct, SetAdded, SetPurchased
  } = useContext(Packs);

  const {
    setOrderExamsCodes, setDiscounted
  } = useContext(BasketContext);
  
  const [ user, setUser ] = useState(null);
  const [ profile, setProfile ] = useState(false);

  const [Name, setName] = useState("");
  const [Gender, setGender] = useState("");
  const [Phone, setPhone] = useState("");
  const [Email, setEmail] = useState("");
  const [Rut, setRut] = useState("");
  const [DoB, setDoB] = useState(new Date());
  const [DoBYear, setDoBYear] = useState(DoB.getFullYear());
  const [DoBMonth, setDoBMonth] = useState(DoB.getMonth()+1);
  const [DoBDay, setDoBDay] = useState(DoB.getDate());
  const [TmpDate, setTmpDate] = useState(new Date());
  const [selectedRegion, setSelectedRegion] = useState("");
  const [selectedCommune, setSelectedCommune] = useState("");
  const [UserPasswordInput, setUserPasswordInput] = useState("");
  const [UserPasswordInput2, setUserPasswordInput2] = useState("");
  const [TOSMissing, setTOSMissing] = useState(false)

  const [UpperTab, setUpperTab] = useState(true);
  const [LoginType, setLoginType] = useState(true);
  const [TaskStart,setTaskStart] = useState(false)
  const [GoogleLog,setGoogleLog] = useState(false)
  const [TaskDone,setTaskDone] = useState(false)
  const [OneTime, setOneTime] = useState(false);

  const Company = window.location.hostname.split('.')[0] === "audionautas" ? "Audionautas" : false
  const regions = Object.keys(allRegions);
  const communes = selectedRegion ? allRegions[selectedRegion] : [];

  const login = useGoogleLogin({
    onSuccess: (codeResponse) => {setUser(codeResponse); setOneTime(true)},
    onError: (error) => console.log('Login Failed:', error)
  });

  // log out function to log the user out of google and set the profile array to null
  const logOut = () => {
      googleLogout();
      setUserPasswordInput("")
      setUserPasswordInput2("")
      setName("")
      setEmail("")
      setSelectedCommune("")
      setSelectedRegion("")
      setProfile(false);
      setUser(null);
      let tmp = validation
      tmp["Email"] = "empty"
      tmp["Name"] = "empty"
      setvalidation({...tmp})
  };

  const GenderChange = useCallback((sex) => {
    let tmp1 = document.getElementById("MaleTile")
    let tmp1I = document.getElementById("MaleTileIcon")
    let tmp2 = document.getElementById("FemaleTile")
    let tmp2I = document.getElementById("FemaleTileIcon")
    if(sex !== "F") {
        if(tmp2.className.includes("DiabetesRiskCalculatorRightSideSurveyQ1ActiveTile")) {
            tmp2.className = tmp2.className.replace(" DiabetesRiskCalculatorRightSideSurveyQ1ActiveTile","")
            tmp2I.className = tmp2I.className.replace(" DiabetesRiskCalculatorRightSideSurveyQ1TileActiveIcon","")
        }
        tmp1.className += " DiabetesRiskCalculatorRightSideSurveyQ1ActiveTile"
        tmp1I.className += " DiabetesRiskCalculatorRightSideSurveyQ1TileActiveIcon"
        setGender(1)
    }
    if(sex !== "M") {
        if(tmp1.className.includes("DiabetesRiskCalculatorRightSideSurveyQ1ActiveTile")) {
            tmp1.className = tmp1.className.replace(" DiabetesRiskCalculatorRightSideSurveyQ1ActiveTile","")
            tmp1I.className = tmp1I.className.replace(" DiabetesRiskCalculatorRightSideSurveyQ1TileActiveIcon","")
        }
        tmp2.className += " DiabetesRiskCalculatorRightSideSurveyQ1ActiveTile"
        tmp2I.className += " DiabetesRiskCalculatorRightSideSurveyQ1TileActiveIcon"
        setGender(2)
    }
  },[setGender])

  function checkRut(rut) {
    // Despejar Puntos
    var valor = rut.trim().replace(".", "");
    // Despejar Guión
    valor = valor.replace("-", "");
    valor = valor.replace(/[^0-9\dkK]/g, "");

    // Aislar Cuerpo y Dígito Verificador
    var cuerpo = valor.slice(0, -1);
    var dv = valor.slice(-1).toUpperCase();

    // Formatear RUN
    setRut(cuerpo.replace("-", "") + "-" + dv);

    // Si no cumple con el mínimo ej. (n.nnn.nnn)
    if (rut === "-") {
      setRut("");
      return false;
    }

    if (cuerpo.length < 7) {

      return false;
    }

    // Calcular Dígito Verificador
    var suma = 0;
    var multiplo = 2;

    // Para cada dígito del Cuerpo
    for (let i = 1; i <= cuerpo.length; i++) {
      // Obtener su Producto con el Múltiplo Correspondiente
      var index = multiplo * valor.charAt(cuerpo.length - i);

      // Sumar al Contador General
      suma = suma + index;

      // Consolidar Múltiplo dentro del rango [2,7]
      if (multiplo < 7) {
        multiplo = multiplo + 1;
      } else {
        multiplo = 2;
      }
    }

    // Calcular Dígito Verificador en base al Módulo 11
    var dvEsperado = 11 - (suma % 11);

    // Casos Especiales (0 y K)
    dv = dv === "K" || dv === "k" ? 10 : dv;
    dv = parseInt(dv) === 0 ? 11 : dv;

    // Validar que el Cuerpo coincide con su Dígito Verificador
    if (parseInt(dvEsperado) !== parseInt(dv)) {
      return false;
    }

    // Si todo sale bien, eliminar errores (decretar que es válido)
    return true;
  }


  const [validation, setvalidation] = useState({
    "Name" : "empty",
    "Gender" : "empty",
    "DoB" : "empty",
    "Phone" : "empty",
    "Email" : "empty",
    "Region" : "empty",
    "Commune" : "empty",
    "Password" : "empty",
    "Password2" : "empty",
    "Rut" : "empty",
  });

  let allvalids = {
    "Name" : "empty",
    "Gender" : "empty",
    "DoB" : "empty",
    "Phone" : "empty",
    "Email" : "empty",
    "Region" : "empty",
    "Commune" : "empty",
    "Password" : "empty",
    "Password2" : "empty",
    "Rut" : "empty",
  };

  const handleName = (value) => {
    const result = value.replace(/\d/g, '');
    setName(result);
  };


  function AgeValidity() {
    const currentDate = new Date();

    const age = currentDate.getFullYear() - new Date(DoB).getFullYear();

    if (age > 18) {
      return true;
    } else if (age === 18) {
      const currentMonth = currentDate.getMonth()+1;
      const currentDay = currentDate.getDate();

      if (currentMonth > DoBMonth || (currentMonth === DoBMonth && currentDay >= DoBDay)) {
        return true;
      }
    }
  
    return false;
  }

  const requestUser = async() => {
    setTaskStart(true)
    MySwal.fire({
      position: "center",
      html: 
      <div className="FullAlertWidth1">
        <div className="FullAlertUpTitle">Registrando Usuario...</div>
        <img alt="" className="FullAlertImageGif" src="https://static.yomecontrolo.cl/public/icons/ymc-loading.gif"/>
      </div>,
      color: "#340066",
      customClass: 'swal-wide',
      showConfirmButton: false,
      width: "100%",
    })

    let params = {
        name: Name,
        rut: Rut,
        email: Email,
        born: (new Date(DoB)).toLocaleDateString('fr-ca'),
        phone: Phone,
        region: selectedRegion,
        commune: selectedCommune,
        pwd: UserPasswordInput,
        gender: Gender
    };
    if(Company) params["company"] = Company
  
    let requestOptions = {
      method: 'POST',
      redirect: 'follow',
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(params)
    };

    try{
      
      const resp = await fetch("https://ymc-doc-api.azurewebsites.net/makeverification", requestOptions)
      if (resp.status !== 200){
        MySwal.close()
        alert("there has been some error");
        return false;
      }
      const data = await resp.json();
      
      if(!data.acknowledged) {
        setTaskStart(false)
        if(data.message === "Rut Exists") {
          return MySwal.fire({
                    icon: "error",
                    title: "Ocurrió un error al crear la cuenta",
                    text: "La cuenta asociada a este rut ya existe",
                    showConfirmButton: true
                  });
        }
        if(data.message === "Email Exists") {
          return MySwal.fire({
                    icon: "error",
                    title: "Ocurrió un error al crear la cuenta",
                    text: "El correo ingresado ya tiene una cuenta asociada",
                    showConfirmButton: true
                  });
        }
        if(data.message === "Corporate1") {
          return MySwal.fire({
                    icon: "error",
                    title: "Ocurrió un error al crear la cuenta",
                    text: "La empresa no se encuentra registrada",
                    showConfirmButton: true
                  });
        }
        if(data.message === "Corporate2") {
          return MySwal.fire({
                    icon: "error",
                    title: "Ocurrió un error al crear la cuenta",
                    text: "La dirección de correo no pertenece a la empresa",
                    showConfirmButton: true
                  });
        }
        return MySwal.fire({
                  icon: "error",
                  title: "Ocurrió un error al crear la cuenta",
                  text: "Por favor inténtelo más tarde",
                  showConfirmButton: true
                });
      }

      MySwal.fire({
        position: "center",
        html: 
        <div className="FullAlertWidth2">
          <div className="FullAlertUpTitle">Hemos creado tu cuenta en yomecontrolo</div>
          <img alt="" className="FullAlertImage" src="https://static.yomecontrolo.cl/public/B2B/AlertImageAccountCreated.png"/>
          <h2 className="FullAlertTitle">Se ha enviado un correo para activar tu cuenta</h2>
          <div className="FullAlertSubtitle">El mail fue enviado a {Email}.</div>
          <div className="GeneralPurpleButtonFlex UserWelcomeBlockPageButton FullAlertButton" onClick={() => MySwal.close()}>
              <div className="GeneralWhiteButtonText">Ok</div>
          </div>
        </div>,
        color: "#340066",
        customClass: 'swal-wide',
        showConfirmButton: false,
        width: "100%",
        allowOutsideClick: false
      })

      //setTaskDone(true)
      if(user) {
        logOut()
      }
      setTaskStart(false)
      setUpperTab(true);
      setUserPasswordInput("");
      setProfile(false)
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
    catch(error){
      //console.log("there has been an error login in")
      MySwal.close()
      alert("Ocurrió un error procesando los resultados")
      return false
    }
  }

  const loginUser = useCallback(async () => {
    setTaskStart(true)

    MySwal.fire({
      position: "center",
      html: 
      <div className="FullAlertWidth1">
          <div className="FullAlertUpTitle">Ingresando...</div>
          <img alt="" className="FullAlertImageGif" src="https://static.yomecontrolo.cl/public/icons/ymc-loading.gif"/>
      </div>,
      color: "#340066",
      customClass: 'swal-wide',
      showConfirmButton: false,
      width: "100%",
    })

    let params = {
        email: LoginType || profile ? Email : false,
        rut: !LoginType && !profile ? Rut : false,
        pwd: UserPasswordInput,
    };
  
    let requestOptions = {
      method: 'POST',
      redirect: 'follow',
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(params)
    };

    try{
      
      const resp = await fetch("https://ymc-doc-api.azurewebsites.net/loginuser", requestOptions)
      if (resp.status !== 200){
        MySwal.fire({
          icon: "error",
          title: "Ocurrió un error al iniciar sesión",
          text: "Error del servidor",
          showConfirmButton: true
        });
        return false;
      }
      const data = await resp.json();
      //console.log(data)
      
      if(!data.userInfo2) {
        setTaskStart(false)
        if(profile) {
          setEmail("")
          setRut("")
          setUserPasswordInput("")
          setProfile(false)
          MySwal.fire({
            icon: "error",
            title: "Ocurrió un error al iniciar sesión",
            text: "La cuenta de Google no tiene una cuenta de YoMeControlo asociada",
            showConfirmButton: true
          });
        } else {
          let valLogin = validation
          valLogin['Email'] = "invalid"
          valLogin['Rut'] = "invalid"
          valLogin['Password'] = "invalid"
          setvalidation({...valLogin})
          MySwal.close()
        }
        return
      }

      sessionStorage.setItem("token",data.userInfo2.token)
      let token = jwtDecode(CryptoJS.AES.decrypt(data.userInfo2.token, process.env.REACT_APP_TOKEN_ENC,{ mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }).toString(CryptoJS.enc.Utf8));
      window.localStorage.setItem("HabitsCalculated",token.health_report)
      setLoggedIn(true)
      setSessionExpired(false)

      MySwal.close()
      setTaskDone(true)
      setTaskStart(false)
    }
    catch(error){
      //console.log("there has been an error login in")
      alert("Ocurrió un error procesando los resultados")
      return false
    }
  },[MySwal, UserPasswordInput, profile, setLoggedIn, setSessionExpired, validation, Email])

  function HandleSubmit() {
    let validRegexEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    let validRegexPhone = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g;

    let accepted = document.getElementById('TOS')

    let isRutValid = checkRut(Rut) ?  "valid" : "invalid"
    let isDoBValid = AgeValidity() ? "valid" : "invalid";
    let isNameValid = Name.trim() === "" ? "invalid" : "valid";
    let isGenderValid = Gender !== 1 && Gender !== 2 ? "invalid" : "valid";
    let isPhoneValid = "valid"
    if(Phone.trim() === "") {
      isPhoneValid = "invalid"
    } else if(!Phone.match(validRegexPhone) || Phone.length < 9 || Phone.length > 11) {
      isPhoneValid = "invalid"
    } else {
      isPhoneValid = "valid"
    }
    let isEmailValid = "valid"
    if(!Email.match(validRegexEmail)) {
      isEmailValid = "invalid"
    } 
    let isRegionValid = selectedRegion === "" ? "invalid" : "valid";
    let isCommuneValid = selectedCommune === "" ? "invalid" : "valid";

    let isPasswordValid = "valid"
    let isPassword2Valid = "valid"
    if(!profile) {
      isPasswordValid = UserPasswordInput.trim() === "" ? "invalid" : UserPasswordInput.length < 8 ? "invalid" : "valid";
      isPassword2Valid = UserPasswordInput !== UserPasswordInput2 || UserPasswordInput2.trim() === "" ? "invalid" : "valid";
    } 
  
    setvalidation({
      "Rut" : isRutValid,
      "DoB": isDoBValid,
      "Name": isNameValid,
      "Phone" : isPhoneValid,
      "Email" : isEmailValid,
      "Region" : isRegionValid,
      "Commune" : isCommuneValid,
      "Password": isPasswordValid,
      "Password2": isPassword2Valid,
      "Gender": isGenderValid,
    });
  
    if (
      isNameValid === "valid" &&
      isGenderValid === "valid" &&
      isDoBValid === "valid" &&
      isPhoneValid === "valid" &&
      isEmailValid === "valid" &&
      isRegionValid === "valid" &&
      isCommuneValid === "valid" &&
      isPasswordValid === "valid" &&
      isPassword2Valid === "valid" &&
      isRutValid === "valid"
    ) {
      if(accepted.checked) {
        setTOSMissing(false)
        requestUser()
      } else {
        setTOSMissing(true)
        return
      }
    } 
  }

  function HandleSubmit2() {
    let validRegexEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    
    let isPasswordValid = UserPasswordInput.trim() === "" ? "invalid" : UserPasswordInput.length < 8 ? "invalid" : "valid";
    let isEmailValid = "valid"
    let isRutValid = !LoginType && checkRut(Rut) ?  "valid" : LoginType ? "empty" : "invalid"
    if(!LoginType) {
      isEmailValid = "empty"
    } else if(!Email.match(validRegexEmail)) {
      isEmailValid = "invalid"
    } 

    let valLogin = validation
    valLogin['Email'] = isEmailValid
    valLogin['Rut'] = isRutValid
    valLogin['Password'] = isPasswordValid
    setvalidation({...valLogin})

    if(((LoginType && isEmailValid === "valid") || (!LoginType && isRutValid === "valid")) && isPasswordValid === "valid") {
      loginUser()
    }
  }

  useEffect(() => {
    if(new Date(TmpDate) !== new Date(DoB)) {
      let dob = new Date(DoB)
      setDoBYear(dob.getFullYear());
      setDoBDay(dob.getDate());
      setDoBMonth(dob.getMonth()+1);
      setTmpDate(DoB)
    }
  },[TmpDate, DoB, setDoBDay, setDoBMonth, setDoBYear]);

  useEffect(() => {
    if (user && !UpperTab && OneTime) {
      axios
          .get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`, {
              headers: {
                  Authorization: `Bearer ${user.access_token}`,
                  Accept: 'application/json'
              }
          })
          .then((res) => {
            setProfile(true);
            setEmail(res.data.email);
            setName(res.data.name);
            setUserPasswordInput(res.data.id)
            let tmp = validation
            tmp["Email"] = "valid"
            tmp["Name"] = "valid"
            setvalidation({...tmp})
            setOneTime(false)
          })
          .catch((err) => console.log(err));
    }
    if (user && UpperTab && OneTime) {
      axios
          .get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`, {
              headers: {
                  Authorization: `Bearer ${user.access_token}`,
                  Accept: 'application/json'
              }
          })
          .then((res) => {
            setProfile(true);
            setEmail(res.data.email);
            setName(res.data.name);
            setUserPasswordInput(res.data.id)
            setGoogleLog(true)
            setOneTime(false)
          })
          .catch((err) => console.log(err));
      }
    },
    [ user, UpperTab, setEmail, setName, validation, OneTime ]
  );

  useEffect(() => {
    if(GoogleLog) {
      loginUser()
      setGoogleLog(false)
    }

    if(TaskDone) {
      Navigate("/perfil-de-usuario")
    }

    if(LoggedOut) {
      sessionStorage.clear()
      setDoB(new Date())
      setName("")
      setPhone("")
      setEmail("")
      setRut("")
      setGender("")
      setSelectedRegion("")
      setSelectedCommune("")
      setUserPasswordInput("")
      setUserPasswordInput2("")
      SetBasketPacks([]) 
      SetExamsPerProduct({})
      SetAdded(false)
      SetPurchased(false)
      setOrderExamsCodes({})
      setDiscounted(0)
      setLoggedIn(false)
      setLoggedOut(false)
      setHabitsCalculated(false)
      setOpenAccess(false)
      SetRelatedExams([])
      SetPreviewRelatedExams([])
    }
  }, [GoogleLog, TaskDone, LoggedOut, loginUser, Navigate, setDoB, setName, setPhone, setEmail, setRut, setGender, setLoggedIn, setLoggedOut, Gender, GenderChange,SetAdded,SetBasketPacks,SetExamsPerProduct,SetPreviewRelatedExams,SetRelatedExams,setDiscounted,setHabitsCalculated,setOrderExamsCodes,setOpenAccess, SetPurchased])

  return (
    <>
      {UpperTab ?
      <div className='SignInContainer2'>
      <div className='SignInGeneralFlexOuter'>
          <div className='SignInLeftSide' style={{backgroundImage:"url('https://static.yomecontrolo.cl/public/B2B/LoginBackgroundFull.jpg')",backgroundPosition: 'center',backgroundSize: 'cover',backgroundRepeat: 'no-repeat'}}>
            <div className='SignInInnerBox'>
              {SessionExpired ? 
                <div className='SignInAlert' style={{ color: "red", fontWeight: "500", textAlign: "center" }}> Su sesión anterior ha expirado</div>
              : null}
              <div className='SignInInnerBoxTabsFlex'>
                <div className='SignInInnerBoxTab SignInInnerBoxActiveTab'>Iniciar Sesión</div>
                {Company ?
                null
                :
                <div className='SignInInnerBoxTab' onClick={() => {setUpperTab(false); setUserPasswordInput(""); setUserPasswordInput2(""); setvalidation({...allvalids});}}>Regístrate</div>
                }
              </div>
              {Company ?
              <>
                <h2 className='SignInInnerBoxTitle'>Portal de Salud del Colaborador</h2>
              </>
              : 
              <>
                <h2 className='SignInInnerBoxTitle'>Bienvenid@ a tu portal de salud</h2>
              </>
              }
              <div className='SignInInnerBoxSubtitle'>Hemos desarrollado herramientas digitales que te permitirán tomar el control de tu salud y bienestar.</div>
              <div className='SignInInnerBoxTabsFlex'>
                <div className={LoginType ? 'SignInInnerBoxTab SignInInnerBoxActiveTab' : 'SignInInnerBoxTab'} style={{fontSize:"14px", paddingBlock:"10px"}} id="EmailType" onClick={() => !LoginType ? setLoginType(true) : null}>Ingresar con correo electrónico</div>
                <div className={!LoginType ? 'SignInInnerBoxTab SignInInnerBoxActiveTab' : 'SignInInnerBoxTab'} style={{fontSize:"14px", paddingBlock:"10px"}} id="RutType" onClick={() => LoginType ? setLoginType(false) : null}>Ingresar con Rut</div>
              </div>
              <div className='SignInInnerBoxInstructions'>Ingresa con tu {LoginType ? "correo" : "rut"} y contraseña</div>
              {LoginType ?
              <div className='SignInInnerBoxInputBlock'>
                <div className='SignInInnerBoxInputBlockText' style={{color: validation["Password"] === "invalid" || validation["Email"] === "invalid" ? "red" : null}}>Correo electrónico</div>
                <input
                  value={profile ? "" : Email}
                  className="SignInInnerBoxInputTile"
                  style={{ borderBottom: validation["Password"] === "invalid" || validation["Email"] === "invalid" ? "red solid 1px" : Email.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Password"] === "invalid" || validation["Email"] === "invalid" ? "#FFFAEA" : Email.length !== 0 ? "#F2F2FF" : "#FBFFFF" }}
                  id="YMCEmail"
                  maxLength={60}
                  type="email"
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Email" />
                  {validation["Email"] === "invalid" ?
                      <div className='SignInAlert' style={{ color: "red", fontWeight: "500" }}> Por favor ingrese email válido</div>
                  : null}
              </div>
              :
              <div className='SignInInnerBoxInputBlock'>
                <div className='SignInInnerBoxInputBlockText' style={{color: validation["Rut"] === "invalid" || validation["Email"] === "invalid" ? "red" : null}}>Rut</div>
                <input
                  value={profile ? "" : Rut}
                  className="SignInInnerBoxInputTile"
                  style={{ borderBottom: validation["Rut"] === "invalid" ? "red solid 1px" : validation["Rut"] === "valid" ? "#8BC53F solid 1px" : Rut.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Rut"] === "invalid" ? "#FFFAEA" : validation["Rut"] === "valid" || Rut.length === 0 || Rut === "-" ? "#FBFFFF" : "#F2F2FF" }}
                  id="YMCRut"
                  maxLength={15}
                  onChange={(e) => checkRut(e.target.value)}
                  placeholder="Ingresa tu rut" />
              </div>
              }
              <div className='SignInInnerBoxInputBlock'>
                <div className='SignInInnerBoxInputBlockText' style={{color: validation["Password"] === "invalid" || validation["Email"] === "invalid" ? "red" : null}}>Contraseña</div>
                <input
                  value={profile ? "" : UserPasswordInput}
                  className="SignInInnerBoxInputTile"
                  style={{ borderBottom: validation["Password"] === "invalid" || validation["Email"] === "invalid" ? "red solid 1px" : UserPasswordInput.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Password"] === "invalid" || validation["Email"] === "invalid" ? "#FFFAEA" : UserPasswordInput.length !== 0 ? "#F2F2FF" : "#FBFFFF" }}
                  id="YMCPwd"
                  type="password"
                  maxLength={30}
                  onChange={(e) => setUserPasswordInput(e.target.value)}
                  placeholder="Ingresa tu contraseña" />
              </div>
              {validation["Password"] === "invalid" || validation["Email"] === "invalid" || validation["Rut"] === "invalid" ?
              <div className='SignInAlert2' style={{ color: "red", fontWeight: "500" }}>{LoginType ? "Email" : "Rut"} o contraseña incorrectos</div>
              : null}
              {TaskStart ?
              <div className='GeneralPurpleButtonFlex SignInInnerBoxLoginButton'> Ingresando... </div>
              :
              <div className='GeneralPurpleButtonFlex SignInInnerBoxLoginButton' onClick={() => HandleSubmit2()}> Ingresar <div className='triangle'><i className='innerarrowWhite'></i></div></div>
      }
              <div className='GeneralWhiteButtonFlex SignInInnerBoxGoogleButton' onClick={() => login()}>Ingresa con Google &ensp;<img alt="" src="https://static.yomecontrolo.cl/public/icons/GoogleIcon.svg" /></div>
              </div>
            </div>
        </div>
        {/*
        <div className='SignInLowerSolutionsFlex' style={{backgroundImage:"url('https://static.yomecontrolo.cl/public/img/home/BackgroundExtraLongWhiteAndSkyblue.png')",backgroundPosition: 'center',backgroundSize: 'cover',backgroundRepeat: 'no-repeat'}}>
          <div className='SignInLowerFirstBlockInnerDiv'>
            <div className='SignInLowerSolutionsLeftBlock'>
              <div className='SignInLowerSolutionsLeftBlockFirstBlock'>
                <div className='SignInLowerSolutionsLeftBlockFirstBlockUpTitle'>Nuestro portal personas</div>
                <h1 className='SignInLowerSolutionsLeftBlockFirstBlockTitle'>Tus herramientas digitales preventivas para cuidar el bienestar</h1>
                <div className='SignInLowerSolutionsLeftBlockFirstBlockSubtitle'>Puedes evaluar el riesgo individual de desarrollar enfermedades en el futuro mediante la medición de factores claves permitirá reducir el riesgo presente y futuro.</div>
              </div>
              <div className='SignInLowerSolutionsRightBlockSecondBlock' style={{backgroundColor:"#CCCCFF"}}>
                <img alt="" className='SignInLowerSolutionsLeftBlockSecondBlockImage' src="https://static.yomecontrolo.cl/public/B2B/ProfileWelcomeImage4_2Vect.svg"/>
                <div className='SignInLowerSolutionsRightBlockSecondBlockTexts'>
                  <h4 className='SignInLowerSolutionsLeftBlockSecondBlockTitle'>Ruta del Bienestar</h4>
                  <div className='SignInLowerSolutionsLeftBlockSecondBlockSubtitle'>Conoce nuestra propuesta personalizada de pasos para cuidar tu salud y bienestar, ¡ponte al día con tu salud!</div>
                  <div className='GeneralPurpleButtonFlex SignInLowerSolutionsLeftBlockSecondBlockButton' onClick={() => { document.body.scrollTop = 0; document.documentElement.scrollTop = 0;}}>Ver mi ruta</div>
                </div>
              </div>
              <div className='SignInLowerSolutionsRightBlockSecondBlock' style={{backgroundColor:"#F2F2FF"}}>
                <img alt="" className='SignInLowerSolutionsLeftBlockSecondBlockImage2' src="https://static.yomecontrolo.cl/public/B2B/ProfileWelcomeImage7Vect.svg"/>
                <div className='SignInLowerSolutionsRightBlockSecondBlockTexts2'>
                  <h4 className='SignInLowerSolutionsLeftBlockSecondBlockTitle2'>Calculadora de Salud</h4>
                  <div className='SignInLowerSolutionsLeftBlockSecondBlockSubtitle2'>Podemos acercarte a un perfilamiento oportuno que identifique riesgos como tu riesgo cardiovascular o diabetes</div>
                  <div className='GeneralPurpleButtonFlex SignInLowerSolutionsLeftBlockSecondBlockButton' onClick={() => { document.body.scrollTop = 0; document.documentElement.scrollTop = 0;}}>Conoce más</div>
                </div>
              </div>
            </div>
            <div className='SignInLowerSolutionsRightBlock'>
              <div className='SignInLowerSolutionsRightBlockSecondBlock' style={{backgroundColor:"#FBFFFF"}}>
                <img alt="" className='SignInLowerSolutionsLeftBlockSecondBlockImage3' src="https://static.yomecontrolo.cl/public/B2B/ProfileWelcomeImage8Vect.svg"/>
                <div className='SignInLowerSolutionsRightBlockSecondBlockTexts'>
                  <h4 className='SignInLowerSolutionsLeftBlockSecondBlockTitle'>Ordenes de Exámenes</h4>
                  <div className='SignInLowerSolutionsLeftBlockSecondBlockSubtitle'>Ahorra tiempo para acudir a tu cuidado descargando tu orden de exámenes médicos de forma online</div>
                  <div className='GeneralPurpleButtonFlex SignInLowerSolutionsLeftBlockSecondBlockButton' onClick={() => { document.body.scrollTop = 0; document.documentElement.scrollTop = 0;}}>Ver más</div>
                </div>
              </div>
              <div className='SignInLowerSolutionsRightBlockSecondBlock' style={{backgroundColor:"#CFF9FF"}}>
                <img alt="" className='SignInLowerSolutionsLeftBlockSecondBlockImage4' src="https://static.yomecontrolo.cl/public/B2B/ProfileWelcomeImage3Vect.svg"/>
                <div className='SignInLowerSolutionsRightBlockSecondBlockTexts2'>
                  <h4 className='SignInLowerSolutionsLeftBlockSecondBlockTitle2'>Informe de Salud</h4>
                  <div className='SignInLowerSolutionsLeftBlockSecondBlockSubtitle2'>Revisa tu informe detallado de salud para tomar control de tus indicadores y aprender a mejorarlos día a día</div>
                  <div className='GeneralPurpleButtonFlex SignInLowerSolutionsLeftBlockSecondBlockButton' onClick={() => { document.body.scrollTop = 0; document.documentElement.scrollTop = 0;}}>Descúbrelo</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='SignInLowerYouCanTrustFlex'>
            <div className='SignInLowerFirstBlockInnerDiv'>
                <div className='SignInLowerYouCanTrustLeftBlock'>
                    <div className='SignInLowerYouCanTrustLeftBlockUpTitle'>Puedes confiar</div>
                    <h1 className='SignInLowerYouCanTrustLeftBlockTitle'>6 Razones para tu tranquilidad con yomecontrolo</h1>
                    <div className='SignInLowerYouCanTrustLeftBlockFlex'>
                        <div className='SignInLowerYouCanTrustBlock'>
                            <div className='SignInLowerYouCanTrustBlockImageContainer'>
                                <img alt="Tiny Checkbox Icon" className='SignInLowerYouCanTrustBlockImage' src="https://static.yomecontrolo.cl/public/icons/PurpleTicket.png"/>
                            </div>
                            <h6 className='SignInLowerYouCanTrustBlockTitle'>Validado por la Superintendencia de salud</h6>
                            <div className='SignInLowerYouCanTrustBlockSubtitle'>El servicio es absolutamente legal. Nuestros médicos cuentan con la validación y supervisión de nuestro país.</div>
                        </div>
                        <div className='SignInLowerYouCanTrustBlock'>
                            <div className='SignInLowerYouCanTrustBlockImageContainer'>
                                <img alt="Tiny Doctor Icon" className='SignInLowerYouCanTrustBlockImage' src="https://static.yomecontrolo.cl/public/icons/PurpleDoctor.png"/>
                            </div>
                            <h6 className='SignInLowerYouCanTrustBlockTitle'>Obtendrás ordenes emitídas por médicos</h6>
                            <div className='SignInLowerYouCanTrustBlockSubtitle'>Las órdenes de exámenes emitidas a través de YMC son generadas por médicos inscritos en la Superintendencia de Salud de Chile</div>
                        </div>
                        <div className='SignInLowerYouCanTrustBlock'>
                            <div className='SignInLowerYouCanTrustBlockImageContainer'>
                                <img alt="Tiny Credit Card Icon" className='SignInLowerYouCanTrustBlockImage' style={{height:"auto"}} src="https://static.yomecontrolo.cl/public/icons/PurpleCreditCard.png"/>
                            </div>
                            <h6 className='SignInLowerYouCanTrustBlockTitle'>Utiliza él método de pago que más te acomode</h6>
                            <div className='SignInLowerYouCanTrustBlockSubtitle'>Webpay Plus, Mercado Pago o transferencia, ¡Tú decides!</div>
                        </div>
                        <div className='SignInLowerYouCanTrustBlock'>
                            <div className='SignInLowerYouCanTrustBlockImageContainer'>
                                <img alt="Tiny Calendar Icon" className='SignInLowerYouCanTrustBlockImage' src="https://static.yomecontrolo.cl/public/icons/PurpleCalendar.png"/>
                            </div>
                            <h6 className='SignInLowerYouCanTrustBlockTitle'>No solo ahorras tiempo, sino también decides cuando usarla</h6>
                            <div className='SignInLowerYouCanTrustBlockSubtitle'>Todas las órdenes de examen emitidas por YMC tienen una vigencia hasta por 60 días.</div>
                        </div>
                        <div className='SignInLowerYouCanTrustBlock'>
                            <div className='SignInLowerYouCanTrustBlockImageContainer'>
                                <img alt="Tiny DNA Icon" className='SignInLowerYouCanTrustBlockImage'  style={{width:"40px"}} src="https://static.yomecontrolo.cl/public/icons/PurpleDNAIconTr.png"/>
                            </div>
                            <h6 className='SignInLowerYouCanTrustBlockTitle'>Úsala en cualquier laboratorio del país</h6>
                            <div className='SignInLowerYouCanTrustBlockSubtitle'>Nuestras ordenes de examen pueden ser utilizadas en cualquier laboratorio privado de Chile.</div>
                        </div>
                        <div className='SignInLowerYouCanTrustBlock'>
                            <div className='SignInLowerYouCanTrustBlockImageContainer'>
                                <img alt="Tiny Money Cycle Icon" className='SignInLowerYouCanTrustBlockImage' src="https://static.yomecontrolo.cl/public/icons/PurpleMoney.png"/>
                            </div>
                            <h6 className='SignInLowerYouCanTrustBlockTitle'>Reembolso de gastos médicos</h6>
                            <div className='SignInLowerYouCanTrustBlockSubtitle'>Con nuestra orden puedes gestionar el reembolso de tus exámenes.</div>
                        </div>
                    </div>
                </div>
                <div className='SignInLowerYouCanTrustRightBlock'>
                    <img alt="" className='SignInLowerYouCanTrustRightBlockImage' src="https://static.yomecontrolo.cl/public/img/home/Lock.png"/>
                </div>
            </div>
        </div> */}
      </div>
    : 
      <div className='SignInContainer2'>
      <div className='SignInGeneralFlexOuter'>
      <div className='SignInLeftSide' style={{backgroundImage:"url('https://static.yomecontrolo.cl/public/B2B/LoginBackgroundFull.jpg')",backgroundPosition: 'center',backgroundSize: 'cover',backgroundRepeat: 'no-repeat'}}>
        <div className='SignInInnerBox2'>
          <div className='SignInInnerBoxTabsFlex'>
            <div className='SignInInnerBoxTab' onClick={() => {setUpperTab(true); setUserPasswordInput(""); setUserPasswordInput2(""); logOut(); setTOSMissing(false); setvalidation({...allvalids});}}>Iniciar Sesión</div>
            <div className='SignInInnerBoxTab SignInInnerBoxActiveTab'>Regístrate</div>
          </div>
          <div className='UserWelcomeBlockPage1TitleFlex'>
              <div className='UserWelcomeBlockPage1Title' style={{marginInline:"auto"}}>Registro de nuevo Usuario</div>
          </div>
          <img alt="" className='SignInInnerBox2BigImage' src="https://ymc.blob.core.windows.net/public/B2B/ProfileWelcomeImage7Vect.png" />
          {profile ? (
          <div className='SignInInnerBoxGoogleRegisterDiv'>
              <div className='GeneralWhiteButtonFlex SignInInnerBoxGoogleButtonRegister' onClick={() => logOut()}>Cerrar cuenta de Google &ensp;<img alt="" src="https://static.yomecontrolo.cl/public/icons/GoogleIcon.svg" /></div>
          </div>
        ) : (
          <div className='SignInInnerBoxGoogleRegisterDiv'>
            <div className='GeneralWhiteButtonFlex SignInInnerBoxGoogleButtonRegister' onClick={() => login()}>Registrarse con Google &ensp;<img alt="" src="https://static.yomecontrolo.cl/public/icons/GoogleIcon.svg" /></div>
            <div className='SignInInnerBoxGoogleRegisterText' style={{marginBlockStart:"10px"}}>Con tu cuenta de Google, no tendrás que guardar una contraseña para este sitio, pero se pedirá el resto de tu información para crear la cuenta. </div>
          </div>
        )}
          <div className='SignInInnerBoxUserDataFlex'>
            <h3 className='SignInInnerBoxUserDataTitle'>Datos de usuario</h3>
            <img alt="" className='SignInInnerBoxUserDataTitlePersonIcon' src="https://static.yomecontrolo.cl/public/icons/HealthCalculatorPurpleMaleIcon.png" id="RegisterPersonIcon"/>
          </div>
          <div className='SignInInnerBoxUserDataSubtitle'>Para nosotros la privacidad es fundamental, por ello y para tu seguridad requerimos que tu nombre sea el usado en tu DNI.</div>
          <div className='SignInInnerBoxInputBlock'>
            <div className="SignInInnerBoxInputBlockFlex">
              <div className='SignInInnerBoxInputBlockText SignInInnerBoxInputBlockTextFlexed' style={{color: validation["Rut"] === "invalid" ? "red" : validation["Rut"] === "valid" ? "#8BC53F" : null}}>Rut*</div>
              <div style={{width:"100%"}}>
                <input
                  value={Rut}
                  className="SignInInnerBoxInputTile"
                  style={{ borderBottom: validation["Rut"] === "invalid" ? "red solid 1px" : validation["Rut"] === "valid" ? "#8BC53F solid 1px" : Rut.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Rut"] === "invalid" ? "#FFFAEA" : validation["Rut"] === "valid" || Rut.length === 0 || Rut === "-" ? "#FBFFFF" : "#F2F2FF" }}
                  id="YMCRut"
                  maxLength={15}
                  onChange={(e) => checkRut(e.target.value)}
                  placeholder="Ingresa tu rut" />
                {validation["Rut"] === "invalid" ?
                  <div className='SignInAlert' style={{ color: "red", fontWeight: "500" }}> Por favor ingrese rut válido</div>
                : null}
              </div>
            </div>
          </div>
          <div className='SignInInnerBoxInputBlock'>
            <div className="SignInInnerBoxInputBlockFlex">
              <div className='SignInInnerBoxInputBlockText SignInInnerBoxInputBlockTextFlexed' style={{color: validation["Name"] === "invalid" ? "red" : validation["Name"] === "valid" ? "#8BC53F" : null}}>Nombre*</div>
              <div style={{width:"100%"}}>
                <input
                  value={Name}
                  className="SignInInnerBoxInputTile"
                  style={{ borderBottom: validation["Name"] === "invalid" ? "red solid 1px" : validation["Name"] === "valid" ? "#8BC53F solid 1px" : Name.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Name"] === "invalid" ? "#FFFAEA" : validation["Name"] === "valid" || Name.length === 0 ? "#FBFFFF" :"#F2F2FF" }}
                  id="YMCName"
                  maxLength={70}
                  onChange={(e) => handleName(e.target.value)}
                  placeholder="Ingresa tu nombre completo" />
                {validation["Name"] === "invalid" ?
                  <div className='SignInAlert' style={{ color: "red", fontWeight: "500" }}> Por favor ingrese nombre válido</div>
                : null}
              </div>
            </div>
          </div>
          <div className='SignInInnerBoxInputBlocksFlex'>
            <div className='SignInInnerBoxInputInnerBlock'>
              <div className="SignInInnerBoxInputBlockFlex2">
                <div className='SignInInnerBoxInputBlockText SignInInnerBoxInputBlockTextFlexed' style={{color: validation["DoB"] === "invalid" ? "red" : validation["DoB"] === "valid" ? "#8BC53F" : null}}>Fecha de <br className="SignInInnerBoxLineBreak"/>Nacimiento*</div>
                <div style={{width:"100%"}}>
                  <input 
                    className="SignInInnerBoxInputTile" 
                    type="date" 
                    id="start" 
                    lang="es"
                    name="trip-start" 
                    style={{ borderBottom: validation["DoB"] === "invalid" ? "red solid 1px" : validation["DoB"] === "valid" ? "#8BC53F solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["DoB"] === "invalid" ? "#FFFAEA" : validation["DoB"] === "valid" || new Date(DoB).toLocaleDateString('fr-ca') === new Date().toLocaleDateString('fr-ca') ? "#FBFFFF" : "#F2F2FF"}}
                    value={new Date(DoB).toLocaleDateString('fr-ca')} 
                    min="1900-01-01" 
                    max={new Date().toLocaleDateString('fr-ca')}
                    onChange={(e) => setDoB(new Date(e.target.value.replace(/-/g, '\/')))} />
                  {validation["DoB"] === "invalid" ?
                      <div className='SignInAlert' style={{ color: "red", fontWeight: "500" }}>Debe tener 18 años o más para crear su perfil de usuario</div>
                  : null}
                </div>
              </div>
            </div>
            <div className='SignInInnerBoxInputInnerBlock'>
              <div className="SignInInnerBoxInputBlockFlex2">
                <div className='SignInInnerBoxInputBlockText SignInInnerBoxInputBlockTextFlexed' style={{color: validation["Gender"] === "invalid" ? "red" : validation["Gender"] === "valid" ? "#8BC53F" : null}}>Sexo*</div>
                <div style={{width:"100%"}}>
                  <div className="DiabetesRiskCalculatorRightSideSurveyQ1TileFlex">
                    <div className={Gender === 1 ? "DiabetesRiskCalculatorRightSideSurveyQ1Tile DiabetesRiskCalculatorRightSideSurveyQ1ActiveTile" : "DiabetesRiskCalculatorRightSideSurveyQ1Tile"} style={{borderBottom: validation["Gender"] === "invalid" ? "red solid 1px" : validation["Gender"] === "valid" ? "#8BC53F solid 1px" : "#BFD4E4 solid 1px", backgroundColor: Gender === 1 ? "#F2F2FF" : Gender === 2 || validation["Gender"] === "empty" ? "white" : "#FFFAEA"}} id="MaleTile" onClick={() => GenderChange("M")}>
                      <div className="DiabetesRiskCalculatorRightSideSurveyQ1TileTitleText">Hombre</div>
                      <img alt="" className={Gender === 1 ? "DiabetesRiskCalculatorRightSideSurveyQ1TileIcon DiabetesRiskCalculatorRightSideSurveyQ1TileActiveIcon" : "DiabetesRiskCalculatorRightSideSurveyQ1TileIcon"} src="https://static.yomecontrolo.cl/public/icons/HealthCalculatorPurpleMaleIcon.png" id="MaleTileIcon"/>
                    </div>
                    <div className={Gender === 2 ? "DiabetesRiskCalculatorRightSideSurveyQ1Tile DiabetesRiskCalculatorRightSideSurveyQ1ActiveTile" : "DiabetesRiskCalculatorRightSideSurveyQ1Tile"} style={{borderBottom: validation["Gender"] === "invalid" ? "red solid 1px" : validation["Gender"] === "valid" ? "#8BC53F solid 1px" : "#BFD4E4 solid 1px", backgroundColor: Gender === 2 ? "#F2F2FF" : Gender === 1 || validation["Gender"] === "empty" ? "white" : "#FFFAEA"}} id="FemaleTile" onClick={() => GenderChange("F")}>
                      <div className="DiabetesRiskCalculatorRightSideSurveyQ1TileTitleText">Mujer</div>
                      <img alt="" className={Gender === 2 ? "DiabetesRiskCalculatorRightSideSurveyQ1TileIcon DiabetesRiskCalculatorRightSideSurveyQ1TileActiveIcon" : "DiabetesRiskCalculatorRightSideSurveyQ1TileIcon"} src="https://static.yomecontrolo.cl/public/icons/HealthCalculatorPurpleFemaleIconT.png" id="FemaleTileIcon"/>
                    </div>
                  </div>
                  {validation["Gender"] === "invalid" ?
                      <div className='SignInAlert' style={{ color: "red", fontWeight: "500" }}> Por favor escoja un género</div>
                  : null}
                </div>
              </div>
            </div>
          </div>
          <div className='SignInInnerBoxInputBlocksFlex'>
            <div className='SignInInnerBoxInputInnerBlock'>
              <div className="SignInInnerBoxInputBlockFlex2">
                <div className='SignInInnerBoxInputBlockText SignInInnerBoxInputBlockTextFlexed' style={{color: validation["Email"] === "invalid" ? "red" : validation["Email"] === "valid" ? "#8BC53F" : null}}>Correo <br className="SignInInnerBoxLineBreak"/>electrónico*</div>
                <div style={{width:"100%"}}>
                  <input
                    value={Email}
                    className="SignInInnerBoxInputTile"
                    style={{ borderBottom: validation["Email"] === "invalid" ? "red solid 1px" : validation["Email"] === "valid" ? "#8BC53F solid 1px" : Email.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Email"] === "invalid" ? "#FFFAEA" : validation["Email"] === "valid" || Email.length === 0 ? "#FBFFFF" : "#F2F2FF" }}
                    id="YMCEmail"
                    maxLength={60}
                    type="email"
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Email" />
                  {validation["Email"] === "invalid" ?
                      <div className='SignInAlert' style={{ color: "red", fontWeight: "500" }}> Por favor ingrese email válido</div>
                  : null}
                </div>
              </div>
            </div>
            <div className='SignInInnerBoxInputInnerBlock'>
              <div className="SignInInnerBoxInputBlockFlex2">
                <div className='SignInInnerBoxInputBlockText SignInInnerBoxInputBlockTextFlexed' style={{color: validation["Phone"] === "invalid" ? "red" : validation["Phone"] === "valid" ? "#8BC53F" : null}}>Número de <br className="SignInInnerBoxLineBreak"/>contacto*</div>
                <div style={{width:"100%"}}>
                  <input
                    value={Phone}
                    className="SignInInnerBoxInputTile"
                    style={{ borderBottom: validation["Phone"] === "invalid" ? "red solid 1px" : validation["Phone"] === "valid" ? "#8BC53F solid 1px" : Phone.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Phone"] === "invalid" ? "#FFFAEA" : validation["Phone"] === "valid" || Phone.length === 0 ? "#FBFFFF" : "#F2F2FF" }}
                    id="YMCPhone"
                    maxLength={20}
                    type="tel"
                    onChange={(e) => setPhone(e.target.value)}
                    placeholder="Tel +56" />
                  {validation["Phone"] === "invalid" ?
                      <div className='SignInAlert' style={{ color: "red", fontWeight: "500" }}> Por favor ingrese teléfono válido</div>
                  : null}
                </div>
              </div>
            </div>
          </div>
          <div className='SignInInnerBoxInputBlocksFlex'>
            <div className='SignInInnerBoxInputInnerBlock'>
              <div className="SignInInnerBoxInputBlockFlex2">
                <div className='SignInInnerBoxInputBlockText SignInInnerBoxInputBlockTextFlexed' style={{color: validation["Region"] === "invalid" ? "red" : validation["Region"] === "valid" ? "#8BC53F" : null}}>Región*</div>
                <div style={{width:"100%"}}>
                  <select
                    className="SignInInnerBoxSelectTile"
                    value={selectedRegion}
                    style={{ borderBottom: validation["Region"] === "invalid" ? "red solid 1px" : validation["Region"] === "valid" ? "#8BC53F solid 1px" : selectedRegion.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Region"] === "invalid" ? "#FFFAEA" : validation["Region"] === "valid" || selectedRegion.length === 0 ? "#FBFFFF" : "#F2F2FF"}}
                    onChange={(e) => {setSelectedRegion(e.target.value); setSelectedCommune("");}}
                  >
                    <option value="">Selecciona una región</option>
                    {regions.map((region) => (
                      <option key={region} value={region}>
                        {region}
                      </option>
                    ))}
                  </select>
                </div>
                {validation["Region"] === "invalid" ?
                      <div className='SignInAlert' style={{ color: "red", fontWeight: "500" }}>Seleccione su región</div>
                  : null}
              </div>
            </div>
            <div className='SignInInnerBoxInputInnerBlock'>
              <div className="SignInInnerBoxInputBlockFlex2">
                <div className='SignInInnerBoxInputBlockText SignInInnerBoxInputBlockTextFlexed' style={{color: validation["Commune"] === "invalid" ? "red" : validation["Commune"] === "valid" ? "#8BC53F" : null}}>Comuna*</div>
                <div style={{width:"100%"}}>
                  <select
                    className="SignInInnerBoxSelectTile"
                    value={selectedCommune}
                    style={{ borderBottom: validation["Commune"] === "invalid" ? "red solid 1px" : validation["Commune"] === "valid" ? "#8BC53F solid 1px" : selectedCommune.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Commune"] === "invalid" ? "#FFFAEA" : validation["Commune"] === "valid" || selectedCommune.length === 0 ? "#FBFFFF" : "#F2F2FF"}}
                    onChange={(e) => setSelectedCommune(e.target.value)}
                    disabled={!selectedRegion}
                  >
                    <option value="">Selecciona una comuna</option>
                    {communes.map((commune) => (
                      <option key={commune} value={commune}>
                        {commune}
                      </option>
                    ))}
                  </select>
                </div>
                {validation["Commune"] === "invalid" ?
                      <div className='SignInAlert' style={{ color: "red", fontWeight: "500" }}>Seleccione su comuna</div>
                  : null}
              </div>
            </div>
          </div>
          {!profile ?
          <>
            <div className='SignInInnerBoxInputBlock'>
            <div className="SignInInnerBoxInputBlockFlex">
              <div className='SignInInnerBoxInputBlockText SignInInnerBoxInputBlockTextFlexed' style={{color: validation["Password"] === "invalid" ? "red" : validation["Password"] === "valid" ? "#8BC53F" : null}}>Contraseña*</div>
              <div style={{width:"100%"}}>
                <input
                  value={UserPasswordInput}
                  className="SignInInnerBoxInputTile"
                  style={{ borderBottom: validation["Password"] === "invalid" ? "red solid 1px" : validation["Password"] === "valid" ? "#8BC53F solid 1px" : UserPasswordInput.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Password"] === "invalid" ? "#FFFAEA" : validation["Password"] === "valid" || UserPasswordInput.length === 0 ? "#FBFFFF" : "#F2F2FF" }}
                  id="YMCPwd"
                  type="password"
                  maxLength={30}
                  onChange={(e) => setUserPasswordInput(e.target.value)}
                  placeholder="Ingresa tu contraseña" />
                {validation["Password"] === "invalid" ?
                  <div className='SignInAlert' style={{ color: "red", fontWeight: "500" }}>Contraseña debe tener al menos 8 caracteres</div>
                : null}
              </div>
            </div>
          </div>
          <div className='SignInInnerBoxInputBlock'>
            <div className="SignInInnerBoxInputBlockFlex">
              <div className='SignInInnerBoxInputBlockText SignInInnerBoxInputBlockTextFlexed' style={{color: validation["Password2"] === "invalid" ? "red" : validation["Password2"] === "valid" ? "#8BC53F" : null}}>Confirmar <br className="SignInInnerBoxLineBreak2"/>Contraseña*</div>
              <div style={{width:"100%"}}>
              <input
                value={UserPasswordInput2}
                className="SignInInnerBoxInputTile"
                style={{ borderBottom: validation["Password2"] === "invalid" ? "red solid 1px" : validation["Password2"] === "valid" ? "#8BC53F solid 1px" : UserPasswordInput2.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Password2"] === "invalid" ? "#FFFAEA" : validation["Password2"] === "valid" || UserPasswordInput2.length === 0 ? "#FBFFFF" : "#F2F2FF" }}
                id="YMCPwd2"
                type="password"
                maxLength={30}
                onChange={(e) => setUserPasswordInput2(e.target.value)}
                placeholder="Ingresa tu contraseña" />
                {validation["Password2"] === "invalid" ?
                  <div className='SignInAlert' style={{ color: "red", fontWeight: "500" }}> Contraseña debe ser igual a la ingresada anteriormente</div>
                : null}
              </div>
            </div>
        </div>
        </>
        : null}
        <div className='SignInInnerBoxInputBlock'>
          <div className='OrderCheckoutBasketTOSFlex'>
            <input type="checkbox" name="acceptTOS" className="OrderCheckoutBasketTOSCheck" id="TOS" />&ensp;
            <div className='OrderCheckoutBasketCouponText'>Acepto los <a className='OrderCheckoutBasketEmailInfoLink' href="https://static.yomecontrolo.cl/public/pdf/GENERAL-TERMS-YMC.pdf" target="_blank" rel="noreferrer">términos y condiciones</a>.</div>
          </div>
          {TOSMissing ?
            <div className='SignInAlert'>Por favor aceptar términos y condiciones.</div>
          : null}
        </div>
        {TaskStart ?
        <div className='GeneralPurpleButtonFlex SignInInnerBoxLoginButton'>Creando usuario...</div>
        : 
        <div className='GeneralPurpleButtonFlex SignInInnerBoxLoginButton' onClick={() => HandleSubmit()}>Crear cuenta de usuario </div>
}
        <div className='SignInInnerBoxLastRegisterText'>*Al registrarse, se le enviará un correo electrónico para confirmar su existencia.</div>
        </div>
        </div>
        </div>
      </div>
      }
    </>
  );
};

export default SigninRoute;